import { render } from "./ViewOrdersReports.vue?vue&type=template&id=511be4aa&scoped=true"
import script from "./ViewOrdersReports.vue?vue&type=script&lang=js"
export * from "./ViewOrdersReports.vue?vue&type=script&lang=js"

import "./ViewOrdersReports.vue?vue&type=style&index=0&id=511be4aa&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-511be4aa"]])

export default __exports__